import { shallowRef } from 'vue';
import type { Division } from '@/shared/contracts';
import { api } from './http';

export const division = shallowRef<Division | null>(null);

let pending: Promise<Division | null> | null = null;

export function loadDivision(): Promise<Division | null> {
  if (!pending) {
    pending = api<Division>('/api/config')
      .then(value => {
        division.value = value;
        if (value.appearance === 'snimk') document.documentElement.dataset.appearance = value.appearance;
        return value;
      })
      .catch(() => {
        pending = null;
        return null;
      });
  }
  return pending;
}
